<!--==============================  HTML  ==============================-->
<template>
  <div class="home">

    <div v-if="!loading" class="think noselect" @click="next_quote"> Think </div>

    <div class="thought"> {{ "..."+( (!loading && quotes.length > 0) ? quotes[selected] : "thinking"  )+"..." }} </div>

    <div class="left_glass noselect"></div>
    <div class="right_glass noselect"></div>

    <div class="content noselect">

      <div class="water2 noselect">
        <div class="sliding-background2 noselect"></div>
      </div>

      <div class="water noselect">
        <div class="sliding-background noselect"></div>
      </div>

      <img class="shower noselect" src="../assets/shower.png">
      <img class="dude noselect" src="../assets/dude.png">
    </div>

    <div class="back_mist noselect"></div>
    <div class="back_wall noselect"></div>
    <div class="back_floor noselect"></div>

  </div>
</template>


<!--==============================  JAVASCRIPT  ==============================-->
<script>
export default {
  name: 'home',

  data () { return {
    quotes: ["Markov Chain generated insights!"],
    selected: 0,
    loading: false,
  } },

  methods: {

    next_quote () {
      if (!this.loading) {
        if (this.quotes.length == 0 || this.quotes.length-1 <= this.selected) {
          this.loading = true;
          this.$http.post('/api/markov', { code: 1, subreddits: ["Showerthoughts"] },
            response => {
              this.selected = 0;
              this.quotes = response.data;
              this.loading = false;
            } );

        } else {
          this.selected += 1;
        }
      }
    },

    get_quotes () {

    }

  }

}
</script>


<!--==============================  CSS  ==============================-->
<style lang="scss" scoped>

.back_wall {
  position: absolute;
  top: -50px;
  left: -50px;
  z-index: 1;
  vertical-align: top;
  width: calc( 100% + 100px );
  height: 450px;
  background: linear-gradient(black, white);
  background-image: url("../assets/tile.png");
  background-repeat: repeat;
  -ms-transform: rotate(2deg); /* IE 9 */
  -webkit-transform: rotate(2deg); /* Safari */
  transform: rotate(2deg);
  filter: blur(2px);
}

.back_floor {
  position: absolute;
  top: -50px;
  left: -50px;
  z-index: 0;
  vertical-align: top;
  width: calc( 100% + 100px );
  height: calc( 100% + 100px );
  background: linear-gradient(black, white);
  background-image: url("../assets/floor.png");
  background-repeat: repeat;
  -ms-transform: rotate(2deg); /* IE 9 */
  -webkit-transform: rotate(2deg); /* Safari */
  transform: rotate(2deg);
  filter: blur(2px);
}

.back_mist {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: linear-gradient(black, white);
  background-image: url("../assets/mist.png");
  background-repeat: repeat;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 375px;
  height: 100%;
  z-index: 2;
}

.dude {
  position: absolute;
  top: 250px;
  right: 30px;
  z-index: 3;
}

.shower {
  position: absolute;
  top: 0px;
  right: 30px;
  z-index: 2;
  width: 150px;
  filter: blur(1px);
}

.water {
  position: absolute;
  top: 90px;
  right: 70px;
  z-index: 3;
  width: 100px;
  height: 450px;
  z-index: 4;
  overflow: hidden;
}

.sliding-background {
  background: url("../assets/rain.png");
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 300%;
  animation: slide 10s linear infinite;
}

.water2 {
  position: absolute;
  top: 90px;
  right: 70px;
  z-index: 3;
  width: 100px;
  height: 450px;
  z-index: 3;
  overflow: hidden;
}

.sliding-background2 {
  background: url("../assets/rain.png");
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 300%;
  animation: slide 10s linear infinite;
}

@keyframes slide {
  0%    { top: -200%; }
  100%  { top: 0; }
}

.left_glass {
  position: absolute;
  top: 0;
  left: 0;
  width: calc( (100% - 375px) / 2 );
  height: 100%;
  z-index: 4;
  background-color: rgba(#3e4864, .6);
  border: 5px #293046 solid;
  border-width: 0 5px 0 0;
}

.right_glass {
  position: absolute;
  top: 0;
  right: 0;
  width: calc( (100% - 375px) / 2 );
  height: 100%;
  z-index: 4;

  background-color: rgba(#3e4864, .6);
  border: 5px #293046 solid;
  border-width: 0 0 0 5px;
}

.think {
  position: absolute;
  top: 160px;
  right: 150px;
  left: 0;
  margin: auto;
  width: 100px;
  background-color: lighten(#2a3752, 5%);
  border: 3px #2a3752 solid;
  z-index: 5;
  color: rgba(#919ebd,0.95);
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-size: 30px;
  font-weight: bold;

  &:hover{
    cursor: pointer;
  }
}

.thought {
  padding: 20px;
  position: absolute;
  top: 460px;
  right: 0;
  left: 0;
  margin: auto;
  max-width: 290px;
  background-color: rgba(#919ebd,0.97);
  border: 5px #2a3752 solid;
  z-index: 5;
  border-radius: 20px;
  font-size: 24px;
  font-weight: bold;
}

</style>
